// extracted by mini-css-extract-plugin
export default {"cta":"PH-z","disabled":"QH-z"};